import React from "react";
import { useLocation } from "react-router-dom";
import StatusBannerStack from "./StatusBannerStack";

function isGuestSurfacePath(pathname: string): boolean {
  if (pathname === "/login" || pathname.startsWith("/login/")) {
    return false;
  }
  if (pathname.startsWith("/admin")) {
    return false;
  }
  if (pathname.startsWith("/online-store")) {
    return false;
  }
  if (pathname.startsWith("/portal")) {
    return false;
  }
  if (pathname.startsWith("/tee-on/portal")) {
    return false;
  }
  return true;
}

/**
 * Shows the guest-surface banner stack on league, tournament, booking, and other
 * guest routes that do not already have a dedicated surface injection.
 */
export default function GuestStatusBanner() {
  const location = useLocation();

  if (!isGuestSurfacePath(location.pathname)) {
    return null;
  }

  return <StatusBannerStack surface="guest" />;
}
